function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}
function extractWidgetId(url) {
  if (typeof url !== 'string') return null;
  const match = url.match(/\/files\/([^_]+?-\d+)(?:_|\.|\?|$)/);
  return match ? match[1] : null;
}

// Ensures every mobile gallery slide that ISN'T the current reeview marker position has a plain
// image if it's missing one. Called both right away and again after videowiseBulkTrigger/initVideowise
// run, because that third-party call is asynchronous and can sometimes clear a slide's content on
// its own timing (its internal state doesn't always match ours immediately) - a single "restore
// once" pass isn't reliable, this needs to be able to catch and fix that after the fact too.
function repairMissingMobileImages(images, mobileMarkerIndex) {
  if (!images || !images.length) return;
  document.querySelectorAll('#gallery-swiper .swiper-slide:not(.swiper-slide-duplicate)').forEach(function(slide) {
    if (slide.classList.contains('js-product-video-slide')) return;
    const idx = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    if (isNaN(idx) || idx === mobileMarkerIndex) return;
    const container = slide.querySelector('.swiper-zoom-container');
    if (!container || container.querySelector('img') || container.querySelector('.vw-product-widget, .reeview-app-widget, [data-videowise-pdp]')) return;
    const replacementSrc = images[idx];
    if (replacementSrc && !replacementSrc.includes('reeview')) {
      const replacementImg = document.createElement('img');
      replacementImg.src = replacementSrc;
      replacementImg.alt = '';
      container.appendChild(replacementImg);
    }
  });
}

let vwGeneration = 0;

const handleSrcChange = debounce((img) => {
  const myGeneration = ++vwGeneration;
  const containers = document.querySelectorAll('.vw-parent');
  if (containers.length > 0) {
    containers.forEach(container => container.classList.remove('vw-parent'));
    
  } 

  let capturedImages = null;
  let capturedMobileMarkerIndex = -1;

  const widgets = document.querySelectorAll('.vw-product-widget');
  if (widgets.length > 0) {
    widgets.forEach(widget => widget.remove());
  }

  const btns = document.querySelectorAll('#cloneVwBtn');
  if (btns.length > 0) btns.forEach(btn => btn.remove());

  const thumbVw = document.querySelector('.thumb');
  const imgvw = thumbVw?.querySelector('img');

  if (thumbVw && imgvw) {
    const prevImg = thumbVw.previousElementSibling;
    imgvw.alt = '';
    if (!prevImg || prevImg.tagName !== 'IMG') {
      const imgClone = imgvw.cloneNode(true);
      thumbVw.parentNode.insertBefore(imgClone, thumbVw);
    } 
  }

   const swatch = document.querySelector('.js-swatch_wrapper.current');
    if (swatch) {
      const images = swatch.dataset.imagesThumb?.split(';') || [];

      document.querySelectorAll('.js-desktop-images-wrapper img:not(.zoomImg)').forEach((imgEl, index) => {
        const imageSrc = images[index];
        if (imageSrc && imageSrc.includes('reeview')) {
            const widgetId = extractWidgetId(imageSrc);
            if (widgetId) {
              imgEl.alt = widgetId || '';
              const lastSegment = widgetId.split('-').pop();
              if (typeof window.__st !== 'undefined' && typeof window.__st.rid !== 'undefined') {
                window.__st.rid = lastSegment;
              }
            }
        }
      });

      const mobileMarkerIndex = images.findIndex(function(src) { return src && src.includes('reeview'); });
      capturedImages = images;
      capturedMobileMarkerIndex = mobileMarkerIndex;

      if (mobileMarkerIndex !== -1) {
        const mobileSlide = document.querySelector(
          '#gallery-swiper .swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' + mobileMarkerIndex + '"]'
        );
        const mobileContainer = mobileSlide ? mobileSlide.querySelector('.swiper-zoom-container') : null;
        if (mobileContainer && !mobileContainer.querySelector('img') && !mobileContainer.querySelector('.vw-product-widget')) {
          const mobileImg = document.createElement('img');
          mobileImg.src = images[mobileMarkerIndex];
          mobileImg.alt = '';
          mobileContainer.appendChild(mobileImg);
        }
      }

      // Restore a plain image into any other slide that lost its widget/image - covers both a
      // slide that held a widget for the previous swatch (now needs no widget) and any slide that
      // otherwise ended up without an image.
      repairMissingMobileImages(images, mobileMarkerIndex);
    }

  if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
    try {
      setTimeout(() => {
        if (myGeneration !== vwGeneration) return;
        videowiseBulkTrigger();
        initVideowise();

        // videowiseBulkTrigger/initVideowise run asynchronously and can - on their own timing,
        // inconsistently - clear a slide's content while rebuilding. Re-run the repair pass after
        // giving them time to settle, so a slide that momentarily got wiped by that third-party
        // call ends up with its image restored rather than staying blank.
        setTimeout(() => {
          if (myGeneration !== vwGeneration) return;
          repairMissingMobileImages(capturedImages, capturedMobileMarkerIndex);
        }, 500);
      }, 120);
    } catch (err) {
      console.error('❌ Error calling Videowise functions:', err);
    }
  }
}, 180);

// Set as soon as the user explicitly changes a swatch, so the page-load fallback below knows to
// back off - it exists only to set up video for the swatch the page happened to load with, and
// re-running it after a real swatch click races against that click's own in-progress VideoWise
// build (VideoWise builds its widget asynchronously, so "no <video> found yet" doesn't mean
// nothing is happening - it can just mean the build hasn't finished). That collision between the
// click's build and this fallback's redundant re-trigger is what made video work only when a
// swatch was changed before window.load had fired, and break afterwards.
let userHasChangedSwatch = false;

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.js-swatch_wrapper');
  if (!swatch) return;
  userHasChangedSwatch = true;
  const img = document.querySelector('.js-desktop-image-item');
  if (!img) {
    return;
  }

  setTimeout(() => {
    handleSrcChange(img);
  }, 120);
});

// Initialize Videowise on page load for the currently selected swatch
function initializeVideowiseOnLoad() {
  let retryCount = 0;
  const maxRetries = 15; // Maximum 3 seconds of retries (15 * 200ms)

  // Wait for DOM to be ready and check if Videowise functions are available
  const checkAndInit = () => {
    if (userHasChangedSwatch) return; // a real click is already handling this - don't collide with it

    const currentSwatch = document.querySelector('.js-swatch_wrapper.current');
    const img = document.querySelector('.js-desktop-image-item');

    if (currentSwatch && img) {
      // Check if Videowise functions are available, if not wait a bit more
      if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
        var existingVideo = document.querySelector('.vw-parent video[src]');
        if (!existingVideo) {
          handleSrcChange(img);
        }
      } else if (retryCount < maxRetries) {
        // Retry after a short delay if functions aren't loaded yet
        retryCount++;
        setTimeout(checkAndInit, 120);
      }
    } else if (retryCount < maxRetries) {
      // Elements not ready yet, retry
      retryCount++;
      setTimeout(checkAndInit, 120);
    }
  };

  // Try multiple times to ensure everything is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(checkAndInit, 280);
    });
  } else {
    // DOM is already ready
    setTimeout(checkAndInit, 280);
  }

  // Also try on window load as a fallback (reset retry count) - but only if the user hasn't
  // already changed swatch by then, since that click's own handler is already in charge.
  window.addEventListener('load', () => {
    if (userHasChangedSwatch) return;
    retryCount = 0;
    setTimeout(checkAndInit, 150);
  });
}

// Start initialization
initializeVideowiseOnLoad();

